<div class="row page-header no-print">
    <div class="col-12">
        <h1>QR Codes <small>Generate QR Code for fuel sources and equipment</small></h1>
    </div>
</div>
<div class="row action-toolbar no-print">
    <div class="col-12">
        <label for="qrSize" style="font-size: 12px">Size</label>
        <input type="number" id="qrSize" class="form-control" style="height: 32px; width: 150px" [(ngModel)]="qrSize" name="qrSize" />
    </div>
</div>

<ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs" (activeIdChange)="tabChanged()" style="margin: 15px 0">
    <li [ngbNavItem]="1" [destroyOnHide]="false">
        <a ngbNavLink>Fueling QR Codes</a>
    </li>
    <li [ngbNavItem]="2" [destroyOnHide]="false">
        <a ngbNavLink>Consumables/Tools QR Codes</a>
    </li>
</ul>

@if (active === 1) {
    <div class="row action-toolbar no-print">
        <div class="col-3">
            <label for="fuelSources">Fuel Sources</label>
            <wj-multi-select
                class="form-control"
                [placeholder]="'Select Fuel Sources'"
                [headerFormat]="'{count:n0} items'"
                [displayMemberPath]="'display'"
                [showSelectAllCheckbox]="true"
                [showFilterInput]="true"
                [itemsSource]="fuelSources"
                (checkedItemsChanged)="filterQr()"
            >
            </wj-multi-select>
        </div>
        <div class="col-3">
            <label for="fuelDestinations">Fuel Destinations</label>
            <wj-multi-select
                class="form-control"
                [placeholder]="'Select Fuel Destinations'"
                [headerFormat]="'{count:n0} items'"
                [displayMemberPath]="'display'"
                [showSelectAllCheckbox]="true"
                [showFilterInput]="true"
                [itemsSource]="fuelDest"
                (checkedItemsChanged)="filterQr()"
            >
            </wj-multi-select>
        </div>
        <div class="col-3">
            <label for="custom">Custom/Other</label>
            <input
                type="text"
                id="custom"
                class="form-control"
                style="height: 32px"
                [(ngModel)]="custom"
                name="custom"
                (ngModelChange)="filterQr()"
            />
        </div>
    </div>
}
@if (active === 2) {
    <div class="row action-toolbar no-print">
        <div class="col-3">
            <label for="consumables">Consumables</label>
            <wj-multi-select
                class="form-control"
                [placeholder]="'Select Consumable'"
                [headerFormat]="'{count:n0} items'"
                [displayMemberPath]="'display'"
                [showSelectAllCheckbox]="true"
                [showFilterInput]="true"
                [itemsSource]="transferableMaterials"
                (checkedItemsChanged)="filterQr()"
            >
            </wj-multi-select>
        </div>
        <div class="col-3">
            <label for="smallTools">Small Tools</label>
            <wj-multi-select
                class="form-control"
                [placeholder]="'Select Small Tools'"
                [headerFormat]="'{count:n0} items'"
                [displayMemberPath]="'display'"
                [showSelectAllCheckbox]="true"
                [showFilterInput]="true"
                [itemsSource]="smallTools"
                (checkedItemsChanged)="filterQr()"
            >
            </wj-multi-select>
        </div>
        <div class="col-3">
            <label for="custom">Custom/Other</label>
            <input
                type="text"
                id="custom"
                class="form-control"
                style="height: 32px"
                [(ngModel)]="custom"
                name="custom"
                (ngModelChange)="filterQr()"
            />
        </div>
    </div>
}

<div class="row" style="margin-top: 10px">
    @for (code of selectedCodes; track code.value) {
        <div class="col-4" style="margin-bottom: 40px">
            <wj-barcode-qr-code class="qr-code" [style.width]="qrSize + 'px'" [style.height]="qrSize + 'px'" [value]="code.value">
            </wj-barcode-qr-code>
            <div class="qr-text" [style.font-size.%]="qrSize" [style.margin-top.px]="qrSize > 150 ? -30 : -8">{{ code.display }}</div>
        </div>
    }
</div>
